import './../vendor/redux-toolkit-1.2.5.umd.min.js';
import {initStore} from './redux-store.js';
import {ChatApiEmitter, parsePerformer, fixPledgeEndTime} from './utils.js';
import {PresenceChannel} from './presence-channel.js';
import {ChatChannel} from './chat-channel.js';
import {EdgeConnection} from './edge-connection.js'
import {createChatHSM} from './chat-hsm.js';
import {
  STATUS_OFFLINE, STATUS_ONLINE, STATUS_AWAY, STATUS_PRIVATE, STATUS_PLEDGE_INIT, STATUS_PLEDGE_SHOW, STATUS_HIDDEN_CAM,
  CHAT_TYPE_OFFLINE, CHAT_TYPE_PUBLIC, CHAT_TYPE_PRIVATE, CHAT_TYPE_SPY, CHAT_TYPE_PLEDGE
} from './const.js';
import { Messenger } from './messenger/messenger.js';
import grayLog from './graylog.js';

const wsEventsToPassToUI = [
  'presence_performers',
  'presence_join_performer',
  'presence_leave_performer',
  'room_abandoned',
];
import {simplePromise} from '../02-utils.js';
export function ChatApiMain(config) {

  const ui_emitter = new ChatApiEmitter();
  const ws_emitter = new ChatApiEmitter();
  const hsm_ready = simplePromise();
  const user_ready = simplePromise();

  if (config.graylog.enabled) {
    grayLog.init(true, config.graylog.url);
  }

  const edgeConnection = new EdgeConnection(ws_emitter);
  this.edgeConnection = edgeConnection;

  const storeController = initStore(ui_emitter);
  const hsm = createChatHSM(this, ws_emitter, ui_emitter, storeController, config.edge);
  //this.hsm = hsm;
  edgeConnection.attach_hsm(hsm);

  this.messenger = new Messenger(storeController, edgeConnection);

  this.on = function (eventName, listener) {
    ui_emitter.addEventListener(eventName, listener);
    if (eventName == 'users') {
      console.log('users ', wsEventsToPassToUI.indexOf(eventName))
    }
    if (wsEventsToPassToUI.indexOf(eventName) > -1) {
      ws_emitter.addEventListener(eventName, listener);
    }
  };
  this.off = function (eventName, listener) {
    ui_emitter.removeEventListener(eventName, listener);
    if (wsEventsToPassToUI.indexOf(eventName) > -1) {
      ws_emitter.removeEventListener(eventName, listener);
    }
  };

  this.setUser = function(user_promise) {
    return Promise.all([user_promise, hsm_ready.promise]).then(([user, hsm]) => {
      console.log('user info ready', user);
      storeController.store.dispatch(storeController.user.actions.receive_user(user));
      grayLog.setUser(user);
      // login user to presence
      hsm.dispatch('user_login_credentials', [user]);
      user_ready.resolve();
    }).catch(error => {
      console.error('failed to get user info', error);
      sentryCaptureException(error);
    });
  };

  this.setPerformer = function (performer_promise) {
    return Promise.all([performer_promise, hsm_ready.promise, user_ready.promise]).then(([performer, hsm]) => {
      console.log('performer info ready', performer);
      fixPledgeEndTime(performer.pledge_configuration, performer.server_time);
      storeController.store.dispatch(storeController.performer.actions.receive_performer(performer));
      // This is initial request to join performer's public chat.
      // it is automatically set when we get performer and whole HSM comes into action
      hsm.dispatch('public_chat_login_request', [performer.public_room]);
    }).catch(error => {
      console.error('failed to get performer info', error);
      sentryCaptureException(error);
    });
  };

  // was made for service worker, not needed now
  /*
  this.on('internal_error', event => {
    var ss = document.createElement("link");
    ss.type = "text/css";
    ss.rel = "stylesheet";
    ss.href = "/embed/iziT/css/iziToast.css";
    document.getElementsByTagName("head")[0].appendChild(ss);
    import('/embed/iziT/js/iziToast.min.js').then(() => {
      iziToast.error({
        position: 'topRight',
        timeout: 50000,
        title: 'Internal Error',
        message: event.detail.reason,
        buttons: [
          ['<button><b>send error report</b></button>', function (instance, toast) {

            instance.hide({transitionOut: 'fadeOut'}, toast, 'button');

          }, true],
          // ['<button>NO</button>', function (instance, toast) {
          //
          //     instance.hide({ transitionOut: 'fadeOut' }, toast, 'button');
          //
          // }],
        ],
      });
    });
  });
  */


  this.guestsMaySendMessages = true;
  this.basicsMaySendMessages = true;
  this.isIgnored = false;

  this.onPermissionsOnSendMessage = function (event) {
    const data = event.detail;
    const oldGuestsMSM = this.guestsMaySendMessages;
    const oldBasicsMSM = this.basicsMaySendMessages;
    this.guestsMaySendMessages = data.guest_allowed;
    this.basicsMaySendMessages = data.basic_allowed;
    const user = this.getUser();

    if (user.isGuest && oldGuestsMSM !== data.guest_allowed) {
      const msgObj = {type: data.guest_allowed ? 'guest_enabled' : 'guest_disabled'};
      storeController.store.dispatch(storeController.chat.actions.message(msgObj));
    } else if (user.isBasic && oldBasicsMSM !== data.basic_allowed) {
      const msgObj = {type: data.basic_allowed ? 'basic_enabled' : 'basic_disabled'};
      storeController.store.dispatch(storeController.chat.actions.message(msgObj));
    }
  }.bind(this);

  ws_emitter.addEventListener('permissions_on_send_message', this.onPermissionsOnSendMessage);

  this.getRoom = function () {
    return storeController.store.getState().chat.room;
  };

  this.startPrivateShow = function () {
    const user = this.getUser();
    if (user.isGuest) {
      this.showLoginModal();
      return;
    }
    if (user.tokens < 10) {
      tokenActivity.getMoreTokens('purchase_tokens_start_private_show');
      return;
    }
    const performer = this.getPerformer();

    // try to spy the show
    if (performer.status === STATUS_PRIVATE) {
      this.startSpyShow();
      return;
    }

    // allow only online and away performers to be asked for private show
    if ([STATUS_ONLINE, STATUS_AWAY].indexOf(performer.status) === -1) {
      console.info('startPrivateShow', 'performer is in status', performer.status);
      return;
    }

    if (performer.privateDisabled) {
      ui_emitter.dispatchEvent(new Event('performer_disabled_private_show'));
      return;
    }

    const cost = performer.true_private_setting ? performer.tariff.true_private : performer.tariff.private;
    if (user.ppu || confirm(`Private session with ${performer.username} costs ${cost} tokens per minute`)) {
      edgeConnection.send({action: 'presence_send_private_chat_invitation', performer_id: performer.id});
    }
  };

  this.startSpyShow = function () {
    const user = this.getUser();
    if (user.isGuest) {
      this.showLoginModal();
      return;
    }
    if (user.tokens < 10) {
      tokenActivity.getMoreTokens('purchase_tokens_start_spy_show');
      return;
    }

    const performer = storeController.store.getState().performer;
    if (performer.status != STATUS_PRIVATE) {
      console.info('startSpyShow', 'performer is in status', performer.status);
      return;
    }

    if (performer.privateDisabled) {
      ui_emitter.dispatchEvent(new Event('performer_disabled_private_show'));
      return;
    }
    if (performer.truePrivateChat) {
      ui_emitter.dispatchEvent(new Event('performer_disabled_spy_private_show'));
      return;
    }

    if (user.ppu || confirm(`Spy session with ${performer.username} costs ${performer.tariff.spy} tokens per minute`)) {
      edgeConnection.send({action: 'presence_spy_private_chat', performer_id: performer.id});
    }
  };

  this.stopPrivateShow = function () {
    const user = this.getUser();
    if (user.isGuest) return;
    const chatType = storeController.store.getState().chat.type;
    if ([CHAT_TYPE_PRIVATE, CHAT_TYPE_SPY].indexOf(chatType) == -1) return;
    hsm.dispatch('user_return_to_public');
  };

  this.sendMessage = function (text) {
    const chatType = storeController.store.getState().chat.type;
    if (chatType == CHAT_TYPE_SPY) {
      console.info('You may not send messages while spying.');
      return;
    }

    const user = this.getUser();
    // check if user may send messages
    if (user.isGuest && !this.guestsMaySendMessages) {
      storeController.store.dispatch(storeController.chat.actions.message({type: 'guest_disabled'}));
      return;
    } else if (user.isBasic && !this.basicsMaySendMessages) {
      storeController.store.dispatch(storeController.chat.actions.message({type: 'basic_disabled'}));
      return;
    }

    // user is in ignore list of the performer
    if (this.isIgnored) {
      //this.chatConn.onNewMessage({ senderName: user.displayname, content: text });
      return;
    }

    edgeConnection.send({action: 'send_message', room: this.getRoom(), message: text});
  };

  this.sendPledgeTokens = function (tokens) {
    const chatType = storeController.store.getState().chat.type;
    if ([CHAT_TYPE_PUBLIC, CHAT_TYPE_PLEDGE].indexOf(chatType) == -1) {
      return;
    }
    const performer = storeController.store.getState().performer;
    edgeConnection.send({action: 'presence_send_pledge_bid', performer_id: performer.id, tokens});
  };

  this.getPledgeBidAmount = function() {
    const { performer: { id: performerId }, pledgeBids } = storeController.store.getState();
    if (!pledgeBids) return 0;
    if (!pledgeBids[performerId]) return 0;
    return pledgeBids[performerId].tokens || 0;
  };

  this.getPledgeChatInfo = function() {
    const { performer: { id: performerId }, pledgeBids } = storeController.store.getState();
    if (!pledgeBids) return null;
    if (!pledgeBids[performerId]) return null;
    return pledgeBids[performerId].pledge_chat_info || null;
  };

  this.showRegisterModal = () => ui_emitter.dispatch('show_register_modal');
  this.showLoginModal = () => ui_emitter.dispatch('show_login_modal');
  this.showUpgradeToPremiumModal = () => ui_emitter.dispatch('show_upgrade_to_premium_modal');

  this.getMoreTokens = function(params) {
    const user = this.getUser();
    if (user.isGuest) {
      this.showLoginModal();
      return;
    }
    const source = params && params.source ? params.source : '';
    tokenActivity.getMoreTokens(source);
  };

  this.needShowConfirmEmailModal = function() {
    const user = this.getUser();
    if (user.isGuest) {
      this.showLoginModal();
      return true;
    }
    if (!user.is_confirmed && user.tokens > 0) {
      ui_emitter.dispatchEvent(new Event('show_confirm_to_tip_modal'));
      return true;
    }
    return false;
  };

  this.showTipModal = function (opts) {
    if (this.needShowConfirmEmailModal()) return;
    ui_emitter.dispatchEvent(new CustomEvent('show_tip_modal', { detail: opts }));
  };

  this.showVibraTipModal = function () {
    if (this.needShowConfirmEmailModal()) return;
    ui_emitter.dispatchEvent(new Event('show_vibratip_modal'));
  };

  this.addTips = function(amount) {
    if (amount < 1) return;
    if (this.needShowConfirmEmailModal()) return;
    const user = this.getUser();
    if (user.tokens < amount) {
      toastr.warning('You need to have more tokens!');
      return;
    }
    const tip_data = {
      tokens: parseInt(amount),
      message: '',
      notify_public: true,
      notify_anonym: false,
    };
    const performer = this.getPerformer();
    const room = this.getRoom() || undefined; // room not required, may send tips to offline performer
    window.tokenActivity.sendTips(tip_data, performer, room);
  };

  this.showGiftModal = function () {
    const user = this.getUser();
    const eventName = user.isGuest ? 'show_login_modal' : 'show_gift_modal';
    ui_emitter.dispatchEvent(new Event(eventName));
  };

  this.showPledgeModal = function () {
    const user = this.getUser();
    if (user.isGuest) {
      this.showLoginModal();
    } else {
      const performer = storeController.store.getState().performer;
      const pledge_configuration = performer.pledge_configuration;
      const min_amount = this.getPledgeBidAmount(performer.id) > 0 ? 1 : pledge_configuration.min_tokens_rate;
      ui_emitter.dispatchEvent(new CustomEvent('show_pledge_modal', {detail: {pledge_configuration, min_amount}}));
    }
  };

  this.getPerformers = function () {
    return storeController.store.getState().performers;
  };

  this.getPerformer = function () {
    return storeController.store.getState().performer;
  };

  this.getUser = function() {
    return storeController.store.getState().user;
  };

  this.updateUserTokens = function (tokens) {
    tokens = parseInt(tokens);
    if (isNaN(tokens) || tokens < 0) {
      console.warn('got incorrect tokens number');
      tokens = 0;
    }
    storeController.store.dispatch(storeController.user.actions.update_tokens(tokens));
  };

  this.updateUserTierLevel = function(level) {
    storeController.store.dispatch(storeController.user.actions.update_tier_level(level));
  };

  this.updateUserVerification = function(verification) {
    storeController.store.dispatch(storeController.user.actions.update_verification(verification));
  };

  this.openChattersList = function() {
    const user = this.getUser();
    if (user.isGuest) {
      this.showLoginModal();
      return;
    }
    this.messenger.openChattersList();
  };

  this.openIMUnreadOrChattersList = function(preferredCollocutor) {
    const user = this.getUser();
    if (user.isGuest) {
      this.showLoginModal();
      return;
    }
    this.messenger.openIMUnreadOrChattersList(preferredCollocutor);
  };

  this.startMessenger = function(performer) {
    const user = this.getUser();
    if (user.isGuest) {
      this.showLoginModal();
      return;
    }
    if (!user.isPremium) {
      this.showUpgradeToPremiumModal();
      return;
    }
    this.messenger.startMessenger(performer);
  };

  this.showMyWebcam = function() {
    const user = this.getUser();
    if (user.isGuest) {
      this.showLoginModal();
      return;
    }
    if (!user.isPremium) {
      this.showUpgradeToPremiumModal();
      return;
    }
    if (!user.webrtc_publish_stream_name) {
      console.error('premium user has no webrtc_publish_stream_name');
      sentryCaptureMessage('premium user has no webrtc_publish_stream_name');
      return;
    }
    ui_emitter.dispatchEvent(new CustomEvent('my_webcam_show', {detail: {webrtc_publish_stream_name: user.webrtc_publish_stream_name}}));
  };

  this.hideMyWebcam = function() {
    ui_emitter.dispatchEvent(new CustomEvent('my_webcam_hide'));
  };


  let isMobileInterface  = false;
  this.isMobileInterface = () => isMobileInterface;
  // dimensions must match css values
  const updateInterfaceType = () => {
    if ((window.matchMedia('(orientation: landscape)').matches && window.innerHeight <= 480)
      || (window.matchMedia('(orientation: portrait)').matches && window.innerWidth <= 768)
    ) {
      isMobileInterface = true;
    } else {
      isMobileInterface = false;
    }
  };
  updateInterfaceType();
  window.addEventListener('resize', updateInterfaceType);

  // ====================================================================
  // ======================= MAIN ENTRY POINT ===========================
  // ====================================================================

  // should be called after dom loaded and all handlers are attached
  this.start = function() {
    console.info('FWC start...', 'config=', config);

    const hsmOptions = {};
    const presence = new PresenceChannel(config, ws_emitter, ui_emitter, storeController);
    const chat = new ChatChannel(config, edgeConnection, ws_emitter, storeController);

    if (0 && config.debug) {
      console.log('add debug to HSM');
      Object.assign(hsmOptions, {
          debug: (message, event) => {

            if (event && typeof message == 'string' && (
              event.type === 'empty'
              || event.type === 'entry'
              || event.type === 'exit'
              || event.type === 'init')) {
              return;
            }
            // if (event.indexOf('Unhandled event') > -1) return; // skip unhandled
            console.debug('HSM:', hsm.currentState().name, message);
          },
          log: (message, event) => {
            console.log('HSM:', hsm.currentState().name, message);
          }
        }
      )
    }

    hsm.run(hsmOptions);
    // login_info_promise.then(login_data => {
    //   storeController.store.dispatch(storeController.user.actions.receive_user(login_data));
    //   hsm.dispatch('user_login_credentials', [login_data]);
    // });

    hsm_ready.resolve(hsm);
  }

}
